export const GET_ALL_SITE_CONTENTS = 'GET_ALL_SITE_CONTENTS'
export const CREATE_SITE_CONTENT = 'CREATE_SITE_CONTENT';
export const UPDATE_SITE_CONTENT = 'UPDATE_SITE_CONTENT';
export const DELETE_SITE_CONTENT = 'DELETE_SITE_CONTENT';